<template>
  <div :class="{ 'has-error': validacao.$error }" class="form-group">
    <label v-if="exibeLabel">
      {{ label }} <sup>{{ labelSup }}</sup>
    </label>
    <select
      :id="id"
      :data-test-id="`select-${id}`"
      :name="id"
      :disabled="somenteLeitura"
      :value="valor"
      :multiple="multiplo"
      class="form-control"
      @change="atualizar($event.target)"
    >
      <option v-if="mostrarTodos" value="">Todos</option>
      <option v-else disabled value="">Selecione</option>
      <option
        v-for="c in convenios"
        :key="c._id"
        :selected="c._id === valor"
        :value="c._id"
      >
        {{ c.nome }}
      </option>
    </select>
    <div v-if="validacao.$dirty" class="help-block">
      <slot name="mensagensValidacao" />
    </div>
  </div>
</template>

<script>
import { campoMixin } from '@/mixins/CampoMixin'
import ConvenioServico from '@/servicos/ConvenioServico'
const convenioServico = new ConvenioServico()

export default {
  name: 'SelecionarConvenio',
  mixins: [campoMixin],
  props: {
    multiplo: {
      type: Boolean,
      default: false,
    },
    mostrarTodos: {
      type: Boolean,
      default: true,
    },
    label: {
      type: String,
      default: 'Convênio',
    },
    id: {
      type: String,
      default: 'convenio',
    },
  },
  data() {
    return {
      convenios: [],
    }
  },
  created() {
    this.recuperarConvenios()
  },
  methods: {
    recuperarConvenios() {
      convenioServico.recuperarTodos({}).then((result) => {
        this.convenios = result.convenios
      })
    },
  },
}
</script>
